import { Filter } from '@core/Entities/Search/SearchFilters/Filter.entity';

import { TrackingDataType } from './Entities/TrackingDataType.entity';
import { createAlertConfirmationToEvent } from './Schemas/CreateAlert/CreateAlertConfirmation/CreateAlertConfirmationToEvent';
import { createAlertEmailConfirmationToEvent } from './Schemas/CreateAlert/CreateAlertEmailConfirmation/CreateAlertEmailConfirmationToEvent';
import { createAlertStartToEvent } from './Schemas/CreateAlert/CreateAlertStart/CreateAlertStartToEvent';
import { searchFiltersToEvent } from './Schemas/SearchFilters/SearchFiltersToEvent';
import { userContextToEvent } from './Schemas/UserContext/UserContextToEvent';
import { prepareFiltersArrayForEvent } from './Utils/PrepareFiltersArrayForEvent';

interface Props {
  pageFilters: Filter[];
  userId: string | null | undefined;
}

interface ReturnData {
  createAlertStart: TrackingDataType;
  createAlertConfirmation: (email: string | undefined, alertFilters: Filter[]) => TrackingDataType;
  createAlertEmailConfirmation: TrackingDataType;
}

export function generateSavedSearchTrackingData({ pageFilters, userId }: Props): ReturnData {
  const userData = {
    userId,
    values: {
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      postcode: '',
      optIns: '',
    },
  };

  // event actions
  const createAlertStartEvent = createAlertStartToEvent();
  const createAlertConfirmationEvent = createAlertConfirmationToEvent();
  const createAlertEmailConfirmationEvent = createAlertEmailConfirmationToEvent();

  // event entities
  const userEvent = userContextToEvent(userData as any);
  const searchFiltersEvent = searchFiltersToEvent(prepareFiltersArrayForEvent(pageFilters));

  return {
    createAlertStart: { event: createAlertStartEvent, context: [userEvent, searchFiltersEvent] },
    createAlertConfirmation: (email: string | undefined, alertFilters: Filter[]) => {
      const userDataWithEmail = { ...userData };
      userDataWithEmail.values.email = email as any;
      const userEventWithEmail = userContextToEvent(userDataWithEmail as any);
      const searchFiltersEvent = searchFiltersToEvent(prepareFiltersArrayForEvent(alertFilters));
      return {
        event: createAlertConfirmationEvent,
        context: [userEventWithEmail, searchFiltersEvent],
      };
    },
    createAlertEmailConfirmation: {
      event: createAlertEmailConfirmationEvent,
      context: [userEvent],
    },
  };
}
